<template>
  <el-drawer @reload="$reloadHandle"
             title="打印" size="55%"
             :before-close="handleClose"
             :visible.sync="drawer"
             direction="rtl"
             :modal-append-to-body="true"
             custom-class="demo-drawer"
             ref="drawer">
    <div style="margin-top: 20px; text-align: center">
      <button @click="print()">打印</button>
    </div>
    <div id="print" style="width: 55mm; height: 88mm; background-color: #fff; font-family: Arial, sans-serif; border-radius: 5px; overflow: hidden;">
      <div id="divPrint" style="width: 100%; height: 100%;">

        <!-- 主内容区域 -->
        <div class="aui-landlady">
          <div class="touBg">
            <div class="gsName"></div>

            <!-- 用户头像 -->
            <div class="aui-mine-user">
              <img :src="item.engineerPic || defaultEngineerPic" alt="">
            </div>

            <!-- 用户信息 -->
            <div class="aui-mine-name">
              <h2>{{ item.engineerName || '李先生' }}</h2>
              <div class="test">服务工程师</div>
              <div class="test2">{{ item.engineerCode || 'GH892365002131' }}</div>
            </div>

            <!-- Logo区域 -->
            <div class="new-logo">
              <img src="/img/logo_img.png" alt="logo" class="new-logo-img">
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import printJS from "print-js";
import api from "@/api/projectApi";
import VueBarcode from "vue-barcode";
import {siteMixins} from "@/mixins/tabChang";


export default {
  name: "engineerFrontPrint",
  props: ['multi', 'param', 'collectPrintIdList', 'dataId'],
  mixins: [siteMixins],
  components: {VueBarcode},
  created() {
    // this.currentTime()

  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      nowDate: null,
      formData: {},
      dataId: null, // 添加dataId属性
      dataList: [{
        qrCodeUrl: '/statics/images/003.jpg', // 测试二维码图片
        orderNo: '202312043312',
        customerName: '李先生',
        phone: '13800138000',
        address: '测试地址',
        partsName: '测试配件',
        quantity: 1,
        price: 100
      }], // 添加测试数据
      drawer: true,
      defaultEngineerPic: "/img/user-logo-001.png",
      item: {
        engineerPic: "/img/user-logo-001.png",
        engineerName: '李先生',
        engineerCode: 'GH892365002131'
      },
      orderDates: []
    };

  },
  methods: {
    handleClose() {
      this.drawer = false;
      this.$emit('update:visiable', false)
    },
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //如果格式是MM则需要此步骤，如果是M格式则此处注释掉
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day <= 9) {
        day = "0" + day;
      }
      let strDate = year + "-" + month + "-" + day;
      this.nowDate = strDate
    },
    getData() {
      // 检查dataId是否存在
      if (!this.dataId) {
        console.warn('No dataId provided, using default values');
        return;
      }

      this.$http.post(api.snSiteEngineer.getDataByIdUrl, {
        id: this.dataId
      }).then(res => {
        // 确保res.data.data存在且不为null
        if (res.data && res.data.data) {
          this.item = res.data.data;
          console.log("itemitemitemitemitem", this.item);
        } else {
          console.warn('No data returned from server, using default values');
        }
      }).catch(error => {
        console.error('Error fetching data:', error);
        // 错误时保持默认值，不将item设置为null
      })
    },
    print() {

      printJS({
        printable: "print", // 标签元素id
        type: "html", // 打印类型
        targetStyles: ["*"],
        scanStyles: false,
        style: `@page {
          margin: 0;
          size: 55mm 88mm; /* 明确指定打印尺寸 */
        }
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          background-color: #fff;
          font-family: "Myriad Set Pro","Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
          margin: 0 !important;
          padding: 0 !important;
        }

        /* 重置样式 */
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        /* 打印区域样式 */
        #print {
          width: 55mm !important;
          height: 88mm !important;
          position: relative !important;
          display: block !important;
          overflow: hidden !important;
          background-color: #fff !important;
          margin: 0 auto !important;
          border-radius: 5px !important;
        }

        /* 确保所有子元素不影响背景显示 */
        #print * {
          position: relative !important;
          z-index: 1 !important;
        }

        /* 顶部标题样式 */
        .top {
          position: relative !important;
          height: 44px !important;
          background: #fff !important;
          text-align: center !important;
          line-height: 44px !important;
          font-size: 18px !important;
          color: #000 !important;
        }

        .top i {
          position: absolute !important;
          left: 15px !important;
          top: 50% !important;
          transform: translateY(-50%) !important;
          width: 20px !important;
          height: 20px !important;
          background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAADp0lEQVRoQ+3aO8gdRRjG8f+DInhBFC0sDCmCVRBtLESiCMaYWyGkEEELMfFWWSgoRNQujZUXVEIsTJoQCwU1RKJJJBBSqGClYiXYiXjXIo+8skdOvnznzOzunN05SaY9M7Pvb+fMbWfEBZZ0gXm5CD7fW7z6FrZ9BfA88BhwPfAX8DHwoqSv2jZQ1WDbNwFHgRtXgf0NPCLpQBt0tWDbtwMfANclQG8AT0lyDrxKsO0HgX3AZTkI4F1JD+XkrQ5s+xLgC+DmHMBUnl2S3k6VqQ4cAdu+tum7t6YAU7//A6yX9N28MlWCG/TVwDGgDfqEpDuXEtwDvUbSD7PQo7ew7Wsk/TwrQNttW/peSUeqBNu+H3gH2CzpZAL9CXBbRp/eKunD6sAN9iAQo/KfwD0J9FXNQDYPfSYWKZJ+rAq8AjuJrQR6r6RHqxq0ZmBLoGNdfYek36sBJ7DT6C2SPpvTp1f+vY8D2yX9kurjg43SmdhJvLExuC8DfRi4FLhLUuyikmkQsO0HYr3bDFDJoJoMOegrY2Em6Y/cShcObrCxhevyrCQ6FzrJ1yWI7Gf0xGb/vbMD6vjWs+ovhC2OXkgLF8ZOo2NwOpX1xmdkKg5eEDbCj2kqRu7o151TUbDth5u1cdF6S2HjLRULbBmwxcDLgi0CXiZsb/CyYXuBlxHbGbys2E5g2zuBN0uO8M2kWmSeTU3QraalBvtWqtIOvw+CbdXCtp8AXu+ASRUZDJsNPh9aNnt7aPtp4JVUM3X4PY5B41NOr7Vx2+fO7cO2nwRea1tpRv7AxvfjrM8yGfVlZ5kJtr0NeH8Bo/Fo2Jl92PYOYH+L89ncNzwqdlWw7buBOJuJE4GSaXTsOWDbceL+DbC2pLTZz8YAFacLo6az+rDtXc0qqmRQg86zqcBXgr+OU/RUoRa/f9qcDA469cyL73+w7YAGuFSqqmXPWXjY3g28XEg7yqIiJ/bpFv4SuCWnUCLP58DGMRYVObH/B7a9Dph7+yWnMiBO8QObfdaTWW+xbBPws8CenrXG+ewGSb/2rGehxSfgOF/d0ONJp5uP5D/1qGOQorJ9ORAHyXHO2iXFTuoZSXG/ovoU4E3Nddy2wf4GPCfp1bYFx8wf4JeAF1oEEVf8or+eAIbor99Kio3MWcn248ANLeKOrN8HOK4Oxe6o1vSRpC2rgLtMo0cD/B4QF8RqTcXBsR08BMQN1hpTWXCNwkXG1Oq79CIDGarui+Ch3vRYz/kX7ghv1eO621EAAAAASUVORK5CYII=') !important;
          background-size: 20px !important;
          background-repeat: no-repeat !important;
        }

        /* 表单容器样式 */
        .form-box {
          padding: 0 !important;
        }

        /* 工牌主体样式 */
        .aui-landlady {
          padding: 0 !important;
          position: relative !important;
          overflow: hidden !important;
          background: #fff !important;
          width: 100% !important;
          height: 100% !important;
          margin: 0 auto !important;
          text-align: center !important;
        }

        /* 背景区域样式 */
        .touBg {
          padding: 0 5px !important;
          width: 100% !important;
          margin-top: 0 !important;
          height: 100% !important;
          position: relative !important;
        }

        /* 公司名称样式 */
        .gsName {
          position: absolute !important;
          top: 35px !important;
          color: #FFF !important;
          font-size: 18px !important;
          left: 26px !important;
        }

        /* 用户头像样式 */
        .aui-mine-user {
          width: 40mm !important;
          height: 45mm !important;
          margin: 2mm auto 0 !important;
          z-index: 9999 !important;
          padding: 0 !important;
        }

        .aui-mine-user img {
          width: 35mm !important;
          height: 45mm !important;
          border: 1px solid rgba(0, 0, 0, 0.1) !important;
          position: relative !important;
          margin: 0 !important;
        }

        /* 用户信息样式 */
        .aui-mine-name {
          margin: 0 !important;
          padding: 0 !important;
        }

        .aui-mine-name h2 {
          font-size: 14px !important;
          color: #000 !important;
          font-weight: 600 !important;
          padding-top: 3px !important;
          margin: 0 !important;
          line-height: 1.2 !important;
        }

        .test {
          color: #1e1e1e !important;
          height: 18px !important;
          line-height: 18px !important;
          font-size: 12px !important;
          margin: 0 !important;
        }

        .test2 {
          height: 18px !important;
          width: 120px !important;
          line-height: 18px !important;
          font-size: 10px !important;
          margin: 0 auto !important;
          border-radius: 15px;
          background: #0D0D0D;
          color: #F5F5F5;
        }

        /* 新Logo区域样式 */
        .new-logo {
          width: 100% !important;
          height: 18mm !important;
          background: url('/img/button_img.png') no-repeat center center !important;
          background-size: 100% 100% !important;
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          margin-top: 0 !important;
          border-bottom-left-radius: 15px;
          border-bottom-right-radius: 15px;
          padding: 0 !important;
        }

        .new-logo-img {
          width: 28mm !important;
          height: auto !important;
          display: block !important;
          margin: 0 !important;
        }`
      });
    }
  },
}
</script>

<style scoped>
  .container1 {
    width: 100%;
    /* margin: 100px auto;
    border: 1px solid #f1f1f1;
    padding: 0 50px 10px; */
    /* background-color: #e9e9e9; */
  }

  .top-img2 {
    /* display: flex; */
    position: relative;
    height: 80px;
    margin-top: 20px;
  }
  .div1{
    width: 36%;
  }

  .div2{
    width: 20%;
  }
  .img1 {
    width: 150px;
    margin-left: 100px;

  }

  .wid4 {
    width: 4%;
  }

  .wid13 {
    width: 13%;
  }

  .wid12 {
    width: 12%;
  }

  .wid16 {
    width: 16%;
   }

  .wid10 {
    width: 10%;
  }

  .wid18 {
    width: 18%;
  }

  .wid6 {
    width: 6%;
  }

   .wid8 {
    width: 8%;
  }

  .wid15 {
    width: 15%;
  }
  .wid14 {
    width: 14%;
  }
  .wid5 {
    width: 5%;
  }
    .wid30 {
    width: 30%;
  }


  .title {
    margin: 0;
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }

  .title1 {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  .img2 {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 50px;

  }

  .top2 {
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }

  .span1 {
    display: inline-block;
    width: 60px;
  }

  .span2 {
    display: inline-block;
  }
  .span6{
    margin-top: 5px;
    width: 200px;
  }
   .print_div_style{
   page-break-after:always;
    margin-top: 10px;
    padding: 0;
    border: none;
  }
  .table-div{
    text-align: center; width: 100%
  }
  .wid25{
    width:25%
  }
  .wid100{
    width: 100%;
  }
  .table-class{
    text-align: center !important;
    border-spacing: 0;
    overflow: hidden;
    table-layout : fixed;
  }
  .none-class{
  width:110px
  }
  .wid85{
  width: 85%;
  }
</style>

<style lang="scss" scoped>
#print {
  * {
    font-size: 11px;
  }

  // 工牌样式
  background-color: #fff;
  min-height: 88mm;
  width: 55mm;

   table {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    text-align: center;
  }

  table th {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
    text-align: center;
  }

  table td {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
  }

  td {
    font-size: 10px;
  }

  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }

  .container1 {
    width: 100%;
    //margin: 100px auto;
    //border: 1px solid #f1f1f1;
    //padding: 0 50px 10px;
    /* background-color: #e9e9e9; */
  }

  .top-img2 {
    /* display: flex; */
    position: relative;
    height: 80px;
    margin-top: 20px;
  }

  .div1 {
    width: 36%;
  }

  .div2 {
    width: 20%;
  }

  .img1 {
    width: 150px;
    margin-left: 100px;

  }

  .title {
    margin: 0;
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }

  .title1 {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  .img2 {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 50px;

  }

  .top2 {
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }

  .span1 {
    display: inline-block;
    width: 60px;
  }

  .span2 {
    display: inline-block;
    /* width: 150px; */
  }

  .span6 {
    margin-top: 5px;
    width: 200px;
  }

  .print_div_style {
    page-break-after: always;
    padding: 0;
    border: none;
    margin-top: 0;
  }

  .wid4 {
    width: 4%;
  }

  .wid13 {
    width: 13%;
  }

  .wid9 {
    width: 9%;
  }

  .wid16 {
    width: 16%;
  }

  .wid10 {
    width: 10%;
  }

  .wid18 {
    width: 18%;
  }

  .wid6 {
    width: 6%;
  }

  .wid5 {
    width: 5%;
  }

  .wid7 {
    width: 7%
  }

  .wid8 {
    width: 8%;
  }

  .wid15 {
    width: 15%;
  }

  .wid5 {
    width: 5%;
  }

  .wid14 {
    width: 14%;
  }

  .wid12 {
    width: 12%;
  }


  .table-div {
    text-align: center;
    width: 100%
  }

  .wid25 {
    width: 25%;
  }

  .wid30 {
    width: 30%;
  }

  .wid100 {
    width: 100%;
  }

  .table-class {
    text-align: center;
    border-spacing: 0;
    overflow: hidden;
    table-layout: fixed;
  }

  .wid85 {
    width: 85%;
  }

  .td-font-size {
    font-size: 10px;
  }

  .td-font-size-small {
    font-size: 6px;
  }

  .th-font-size {
    font-size: 10px;
  }

  td th {
    height: 14.5px;
    overflow: hidden;
    white-space: nowrap;
  }

  .font-left {
    text-align: left !important;
  }

  .font-center {
    text-align: center !important;
  }

  .test2 {
    height: 18px !important;
    width: 120px !important;
    line-height: 18px !important;
    font-size: 10px !important;
    margin: 0 auto !important;
    border-radius: 15px;
    background: #0D0D0D;
    color: #F5F5F5;
  }


  /* 新增logo样式 */
  .new-logo {
    position: relative;
    width: 100%;
    height: 20mm;
    background: url(/img/button_img.png) no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 5px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .new-logo-img {
    width: 30mm;
    height: auto;
    align-items: center;
    display: block;
  }
}
</style>
